<!-- BillerActionSelectList.vue -->
<script lang="ts" setup>
    import { DisplayStyle, IconTypes } from '../../Enums/UiEnums';
    import { PrivilegeType, AppScreens } from '../../Enums/ChoiceEnums';

    import { initPinia } from '../../lib/PiniaMgr';
    import { usePrivilegesStore } from '../../lib/Stores/PrivilegesStore'

    import * as _ from 'lodash';
    import { computed, onMounted, ref } from 'vue';
    import * as ChoiceApi from '../../lib/ChoiceApi';
    import { ModalWindowOpenByName } from '../../lib/ChoiceUserConfiguration';
    import Icon from '../../components/Icon.vue'

    const props = withDefaults(defineProps<{
        billerActionId?: number
    }>(), {
        // Default values
    });

    const emit = defineEmits<{
        (e: "update:billerActionId", billerActionId: number): void
    }>();
    
    const privilegesStore = usePrivilegesStore(initPinia());

    const billingActionOptions = ref<ChoiceApi.IBillingActionOption[]>([]);

    onMounted(() =>{
        // Get info for claim comments
        ChoiceApi.billingActions.options()
            .then(resp => billingActionOptions.value = resp);        
    });

    const visibleBillingActionOptions = computed(() => {
        // Show biller action (make in-active visible if selected)
        return billingActionOptions.value.filter(act => act.active || act.biller_action_id === props.billerActionId);
    });


    function ChangeBillerAction(changeEvent: Event)
    {
        const billerActionId = +(<HTMLInputElement>changeEvent.target).value;
        emit("update:billerActionId", billerActionId);
    }

    async function ShowBillerActionEditor()
    {
        await ModalWindowOpenByName(AppScreens.BillerAction);
        billingActionOptions.value = await ChoiceApi.billingActions.options();
    }

</script>

<template>
    <div class="input-group mb-3">
        <select :value="props.billerActionId" class="form-select" @change="ChangeBillerAction"
            :disabled="!(privilegesStore.screens[AppScreens.BillerAction] >= PrivilegeType.Read)">
            <option :value="undefined"></option>
            <option v-for="opt in _.orderBy(visibleBillingActionOptions, i => i.description)" :value="opt.biller_action_id">
                {{ opt.description }}
                <template v-if="!opt.active"> (Inactive)</template>
            </option>
        </select>
        <div class="input-group-append ms-1" v-if="privilegesStore.screens[AppScreens.BillerAction] >= PrivilegeType.ReadUpdate">
            <button class="btn btn-primary" title="Edit/Add biller action options" @click="ShowBillerActionEditor">
                <Icon :icon="IconTypes.Edit" :displayStyle="DisplayStyle.Light" />
            </button>
        </div>
    </div>
</template>